module.exports = __webpack_public_path__ + "static/media/augur.7c29639c.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/augur.svg
// module id = 1144
// module chunks = 0